// activated by running :
// npm run build -- --configuration=dev
// OR
// npm run build-dev

export const environment = {
    production: false,
    branch: 'develop',
    version: '3.11.0',
    enableDevToolRedux: true,
    environmentLabel: 'DEVELOPMENT',
};
